import type { NextApiRequest, NextApiResponse } from 'next'
import { type Language, type PaymentProviderConfig, type ShippingProviderConfig } from 'ecosystem'
import { useLocaleCredentials as setLocaleCredentials } from 'api'
import { handlerWithLogging } from '../../../logging'
import { qliroPaymentProvider } from './qliroPaymentProvider'

export interface ValidateOrderHandlerOpts {
  paymentProviderConfig?: PaymentProviderConfig
  shippingProviderConfig?: ShippingProviderConfig
}

export const validateOrderHandler = handlerWithLogging(
  async (req: NextApiRequest, res: NextApiResponse, opts?: ValidateOrderHandlerOpts) => {
    if (req.method !== 'POST') {
      res.status(405).json({ error: 'Method not supported.' })
      return
    }

    const locale = (req.cookies.NEXT_LOCALE as Language) || 'sv'
    setLocaleCredentials(locale)

    const queryOrderId = req.query.order_id

    if (!queryOrderId) {
      res.status(400).json({ error: 'Missing query params.' })
      return
    }

    const orderId = String(queryOrderId)

    switch (opts?.paymentProviderConfig?.providerName ?? 'KLARNA') {
      case 'QLIRO':
        return qliroPaymentProvider(req, res, {
          orderId,
          shippingProviderName: opts?.shippingProviderConfig?.provider
        })
      default:
        res.status(200).json({ success: true })
    }
  }
)
